import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton com dimensões fixas para JobCard
 * Mantém mesmo height do componente real para evitar CLS
 */
export function JobCardSkeleton() {
  return (
    <Card className="p-4 md:p-6 w-full max-w-2xl mx-auto min-h-[200px]">
      {/* Header: Logo + Title + Company */}
      <div className="flex items-start gap-4">
        <Skeleton className="h-12 w-12 rounded-lg shrink-0" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
      
      {/* Tags: Location, Type */}
      <div className="flex flex-wrap gap-2 mt-4">
        <Skeleton className="h-6 w-20 rounded-full" />
        <Skeleton className="h-6 w-24 rounded-full" />
        <Skeleton className="h-6 w-16 rounded-full" />
      </div>
      
      {/* Button */}
      <Skeleton className="h-10 w-full mt-4 rounded-md" />
    </Card>
  );
}

export function JobCardSkeletonList({ count = 3 }: { count?: number }) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <JobCardSkeleton key={i} />
      ))}
    </div>
  );
}
